import { RepeatIcon, WarningTwoIcon } from "@chakra-ui/icons";
import { ContactFootnote } from "components/common/contact-footnote";
import settings from "config/settings.json";
import { ErrorLayout } from "layouts/error";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

const { healthCheck: { serviceUnavailableContactEmail: CONTACT_EMAIL } } = settings;

/**
 * Generic error component that displays an error message, a button to reload the page, and a link back to sign-in.
 */
function ErrorComponentFootnote() {
  return (
    <ContactFootnote
      testId="contact-support-link"
      email={CONTACT_EMAIL}
      i18nKey="error.contactFootnote"
      defaultText="If the problem persists, <contactLink>contact support</contactLink>."
    />
  );
}

export function ErrorComponent() {
  const { t } = useTranslation();
  const title = t("error.title", "Something went wrong");
  const message = t("error.message", "An unexpected error occurred. Please try again.");
  const tryAgain = t("error.tryAgain", "Try again");
  const backToHomePage = t("error.backToHomePage", "Back to home page");

  const onTryAgain = useCallback(() => {
    // Reload, in case the error was transient.
    window.location.reload();
  }, []);

  const onBackToHomePage = useCallback(() => {
    // Return the user to the home page.
    window.location.href = "/";
  }, []);

  return (
    <ErrorLayout
      title={title}
      heading={title}
      icon={<WarningTwoIcon />}
      message={message}
      messageTestId="error"
      footnote={<ErrorComponentFootnote/>}
      actions={[
        {
          text: tryAgain,
          testId: "try-again-button",
          onClick: onTryAgain,
          primary: true,
          icon: <RepeatIcon />
        },
        {
          text: backToHomePage,
          testId: "back-to-home-page",
          onClick: onBackToHomePage
        }
      ]}/>
  );
}
